export const enum PublishedProjectErrors {
  LIMITS_EXCEEDED = 'This project cannot be currently displayed, because view limits were exceeded.',
  PUBLISH_NOT_FOUND = 'Publish URL is invalid.',
  PUBLISH_INVALID = 'Publish files are corrupted.',
  INCORRECT_PASSWORD = 'Provided password is incorrect.',
}
